export const PERFIL = {
    
    MASTER: "MASTER",
    ADMIN: "ADMIN",
    CADASTRO_CURSO: "CADASTRO_CURSO",
    CADASTRO_VESTIBULAR: "CADASTRO_VESTIBULAR",
    CANDIDATO: "CANDIDATO",
    ADMINISTRATIVO: "ADMINISTRATIVO"
    
}